// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WhyHostForm-commonHeaderAdmin-gjqV2 {
	position: fixed !important;
}

.WhyHostForm-adminLayout-OBKga {
	padding-top: 64px !important;
}

.WhyHostForm-box-ctSTP h2 {
	font-size: 21px;
	font-weight: 600;
}

.WhyHostForm-exportLink-mEl4q {
	margin-bottom: -29px;
}

.WhyHostForm-blockCenter-TlP9V {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.WhyHostForm-panelHeader-dpvV6 {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.WhyHostForm-currencyselect-cXpbU {
	width: 100%;
	margin-right: 0px;
}

.WhyHostForm-panelHeader-dpvV6 {
	overflow: hidden;
	position: relative;
}

.WhyHostForm-mar0-XxAp5 {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.WhyHostForm-blockCenter-TlP9V {
		padding: 0px;
	}

	.WhyHostForm-panelHeader-dpvV6 {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.WhyHostForm-sideAdminPageWrapper-a1Vto {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.WhyHostForm-panelHeader-dpvV6 {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.WhyHostForm-table-YoHvS {
	display: table;
}

.WhyHostForm-tableRow-hOJQh {
	display: table-row;
}

.WhyHostForm-tableCell-CovJO {
	display: table-cell;
	float: none;
}

.WhyHostForm-formGroup-Rn3GH {
	margin-bottom: 6px;
}

.WhyHostForm-select-FtRRv {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.WhyHostForm-noMargin-oQjLM {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.WhyHostForm-exportLink-mEl4q {
	padding-top: 10px;
	padding-right: 10px;
}

.WhyHostForm-labelTextNew-fkbve {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.WhyHostForm-displayInline-C1pFo {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.WhyHostForm-btnUPdate-muXLd {
	display: inline-block;
}

.WhyHostForm-btnModalDelete-mAC49 {
	display: inline-block;
	margin-left: 15px;
}

.WhyHostForm-radioBtn-pfeZY {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.WhyHostForm-backgroundImg-mkpl7 {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.WhyHostForm-btnUPdate-muXLd {
		display: block;
		margin-bottom: 12px;
	}

	.WhyHostForm-btnModalDelete-mAC49 {
		display: block;
		margin-left: 0px;
	}

	.WhyHostForm-btnWidth-YLSLf {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.WhyHostForm-bannerImageBg-J2CTm {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.WhyHostForm-bannerDelete-jqACp {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.WhyHostForm-modalRoot-k1UC6 {
	padding: 32px;
}

.WhyHostForm-modalBorderBottom-G1huq {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.WhyHostForm-logInModalBody-iBNMH {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.WhyHostForm-exportSection-hZ6Y7 {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.WhyHostForm-exportSectionGridSub-FS70i {
	grid-template-columns: 50% 49% !important;
}

.WhyHostForm-exportText-PohoY {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.WhyHostForm-exportLinkImg-g1BJ9 {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.WhyHostForm-vtrMiddle-NQPe_ {
	vertical-align: middle;
}

.WhyHostForm-exportImg-ZxT4S {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.WhyHostForm-profileViewlabel-YH36v {
	display: inline-block;
	width: 38%
}

.WhyHostForm-profileViewMainContent-Z2s1F {
	display: inline-block;
	width: 62%;
}

.WhyHostForm-profileViewMain-JGccD {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.WhyHostForm-profileViewInner-NnSTa {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.WhyHostForm-profileImageSection-dOdwY {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.WhyHostForm-lastviewInner-OObuN {
	padding: 10px;
}

.WhyHostForm-whyHostHoriLine-DgyNz {
	margin: 30px 0;
}

.WhyHostForm-tableGrid-PSs0q {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.WhyHostForm-headingContent-JL04G {
	font-size: 18px;
	font-weight: 500;
}

.WhyHostForm-refundTextColor-YAI9s {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.WhyHostForm-dividerLine-UGb8p {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.WhyHostForm-smallContent-ZaEJg {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.WhyHostForm-sideAdminPageWrapper-a1Vto {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.WhyHostForm-sideAdminPageWrapper-a1Vto {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.WhyHostForm-exportSection-hZ6Y7 {
		grid-template-columns: 100%;
	}

	.WhyHostForm-exportSectionGridSub-FS70i {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.WhyHostForm-profileViewlabel-YH36v {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.WhyHostForm-profileViewMainContent-Z2s1F {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.WhyHostForm-ChangeToUpperCase-Jpqbs {
	text-transform: uppercase
}

.WhyHostForm-noBorder-hSwr1 {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.WhyHostForm-siteAdminHeading-zabNO {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.WhyHostForm-siteAdminSubHeading-zP3E9 {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.WhyHostForm-adminFormDivider-NqP8a {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.WhyHostForm-errorMessage-Y6b3I {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.WhyHostForm-panelHeader-dpvV6 {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.WhyHostForm-formGroup-Rn3GH {
  margin-bottom: 6px;
}

.WhyHostForm-select-FtRRv {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.WhyHostForm-labelText-xSLGb {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.WhyHostForm-space1-sR4LQ {
	margin-bottom: 6px !important;
}

.WhyHostForm-space2-xzAJW {
	margin-bottom: 12px !important;
}

.WhyHostForm-space3-iaMq8 {
	margin-bottom: 18px !important;
}

.WhyHostForm-space4-cO_Cj {
	margin-bottom: 24px !important;
}

.WhyHostForm-space5-DR0nz {
	margin-bottom: 30px !important;
}

.WhyHostForm-space6-OCpKi {
	margin-bottom: 36px !important;
}

.WhyHostForm-space7-h844H {
	margin-bottom: 42px !important;
}

.WhyHostForm-spaceTop8-exqRy {
	margin-bottom: 48px !important;
}

.WhyHostForm-spaceTop1-wrM4o {
	margin-top: 6px !important;
}

.WhyHostForm-spaceTop2-UnHZ2 {
	margin-top: 12px !important;
}

.WhyHostForm-spaceTop3-IQAPt {
	margin-top: 18px !important;
}

.WhyHostForm-spaceTop4-IbSSw {
	margin-top: 24px !important;
}

.WhyHostForm-spaceTop5-RPUvF {
	margin-top: 30px !important;
}

.WhyHostForm-spaceTop6-SKeYS {
	margin-top: 36px !important;
}

.WhyHostForm-spaceTop7-NoZID {
	margin-top: 42px !important;
}

.WhyHostForm-spaceTop8-exqRy {
	margin-top: 48px !important;
}

.WhyHostForm-noMargin-oQjLM {
	margin: 0px !important;
}

.WhyHostForm-padding1-CZFO8 {
	padding-bottom: 6px !important;
}

.WhyHostForm-padding2-j4xJy {
	padding-bottom: 12px !important;
}

.WhyHostForm-padding3-M6eaT {
	padding-bottom: 18px !important;
}

.WhyHostForm-padding4-zKVMO {
	padding-bottom: 24px !important;
}

.WhyHostForm-padding5-IPf6l {
	padding-bottom: 30px !important;
}

.WhyHostForm-padding6-tl3xh {
	padding-bottom: 36px !important;
}

.WhyHostForm-padding7-OyCdl {
	padding-bottom: 42px !important;
}

.WhyHostForm-paddingTop1-hfftI {
	padding-top: 6px !important;
}

.WhyHostForm-paddingTop2-jy50P {
	padding-top: 12px !important;
}

.WhyHostForm-paddingTop3-acB1e {
	padding-top: 18px !important;
}

.WhyHostForm-paddingTop4-gHQiW {
	padding-top: 24px !important;
}

.WhyHostForm-paddingTop5-UWp8A {
	padding-top: 30px !important;
}

.WhyHostForm-paddingTop6-ancA_ {
	padding-top: 36px !important;
}

.WhyHostForm-paddingTop7-Rl2ZF {
	padding-top: 42px !important;
}

.WhyHostForm-noPadding-dVw_l {
	padding: 0px !important;
}

.WhyHostForm-textBold-zQ3aE {
	font-weight: 500 !important;
}

.WhyHostForm-textBolder-XpWvP {
	font-weight: 700 !important;
}

.WhyHostForm-textNormal-htzyD {
	font-weight: normal !important;
}

.WhyHostForm-spaceBottom20-acCQh {
	margin-bottom: 20px;
}

.WhyHostForm-spaceBottom10-wDFta {
	margin-bottom: 10px;
}

.WhyHostForm-marginNone-JV1dw {
	margin: 0;
}

.WhyHostForm-spaceBottom15-itRBu {
	margin-bottom: 15px;
}

.WhyHostForm-marginTopNone-MQ305 {
	margin-top: 0;
}

.WhyHostForm-spaceTop11-w6tda {
	margin-top: 11px;
}

.WhyHostForm-spaceTop21-F_jr0 {
	margin-top: 21px;
}

.WhyHostForm-spaceTop20-VgSQ_ {
	margin-top: 20px;
}

.WhyHostForm-spaceTop10-sol1h {
	margin-top: 10px;
}

/*New Design Text Colors */

.WhyHostForm-textDarkBlue-sr85l {
	color: rgb(20, 39, 94) !important;
}

.WhyHostForm-textLightBlue-MK289 {
	color: rgb(57, 87, 106) !important;
}

.WhyHostForm-textLightSandleGreen-KaP9B {
	color: rgb(76, 86, 41) !important;
}

.WhyHostForm-textLightBrown-B3ypj {
	color: rgb(115, 79, 33) !important;
}

.WhyHostForm-textMediumMaroon-lcmOs {
	color: rgb(87, 37, 51) !important;
}

.WhyHostForm-textBrown-KDmjw {
	color: rgb(160, 47, 24) !important;
}

.WhyHostForm-textMaroon-wP_25 {
	color: rgb(155, 49, 67) !important;
}

.WhyHostForm-textDarkBrown-aJqYA {
	color: rgb(83, 18, 16) !important;
}

.WhyHostForm-textMediumBrown-ZnHIC {
	color: rgb(142, 28, 10) !important;
}

.WhyHostForm-textSkyBlue-_KE_d {
	color: rgb(37, 117, 141) !important;
}

.WhyHostForm-textGray-q96fV {
	color: rgb(77, 65, 51) !important;
}

.WhyHostForm-sectionBorder-SdVGP {
    border: 1px solid var(--primary-border);
    border-radius: 6px;
    margin-bottom: 25px;
    padding: 15px;

}

.WhyHostForm-removeIcon-wXEFX:hover {
    cursor: pointer;
}

.WhyHostForm-removeIcon-wXEFX {
    width: 26px;
}

.WhyHostForm-whyFromGrid-G8Bgg {
    display: grid;
    grid-template-columns: 49% 49%;
    grid-column-gap: 22px;
}

@media screen and (max-width: 1199px) {
    .WhyHostForm-whyFromGrid-G8Bgg {
        grid-template-columns: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/WhyHostForm/WhyHostForm.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;ACxNA;IACI,uCAAuC;IACvC,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;;AAEjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../admin-common.css';\n@import '../admin-form.css';\n@import '../../helpers.css';\n\n.sectionBorder {\n    border: 1px solid var(--primary-border);\n    border-radius: 6px;\n    margin-bottom: 25px;\n    padding: 15px;\n\n}\n\n.removeIcon:hover {\n    cursor: pointer;\n}\n\n.removeIcon {\n    width: 26px;\n}\n\n.whyFromGrid {\n    display: grid;\n    grid-template-columns: 49% 49%;\n    grid-column-gap: 22px;\n}\n\n@media screen and (max-width: 1199px) {\n    .whyFromGrid {\n        grid-template-columns: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `WhyHostForm-commonHeaderAdmin-gjqV2`,
	"adminLayout": `WhyHostForm-adminLayout-OBKga`,
	"box": `WhyHostForm-box-ctSTP`,
	"exportLink": `WhyHostForm-exportLink-mEl4q`,
	"blockCenter": `WhyHostForm-blockCenter-TlP9V`,
	"panelHeader": `WhyHostForm-panelHeader-dpvV6`,
	"currencyselect": `WhyHostForm-currencyselect-cXpbU`,
	"mar0": `WhyHostForm-mar0-XxAp5`,
	"sideAdminPageWrapper": `WhyHostForm-sideAdminPageWrapper-a1Vto`,
	"table": `WhyHostForm-table-YoHvS`,
	"tableRow": `WhyHostForm-tableRow-hOJQh`,
	"tableCell": `WhyHostForm-tableCell-CovJO`,
	"formGroup": `WhyHostForm-formGroup-Rn3GH`,
	"select": `WhyHostForm-select-FtRRv`,
	"noMargin": `WhyHostForm-noMargin-oQjLM`,
	"labelTextNew": `WhyHostForm-labelTextNew-fkbve`,
	"displayInline": `WhyHostForm-displayInline-C1pFo`,
	"btnUPdate": `WhyHostForm-btnUPdate-muXLd`,
	"btnModalDelete": `WhyHostForm-btnModalDelete-mAC49`,
	"radioBtn": `WhyHostForm-radioBtn-pfeZY`,
	"backgroundImg": `WhyHostForm-backgroundImg-mkpl7`,
	"btnWidth": `WhyHostForm-btnWidth-YLSLf`,
	"bannerImageBg": `WhyHostForm-bannerImageBg-J2CTm`,
	"bannerDelete": `WhyHostForm-bannerDelete-jqACp`,
	"modalRoot": `WhyHostForm-modalRoot-k1UC6`,
	"modalBorderBottom": `WhyHostForm-modalBorderBottom-G1huq`,
	"logInModalBody": `WhyHostForm-logInModalBody-iBNMH`,
	"exportSection": `WhyHostForm-exportSection-hZ6Y7`,
	"exportSectionGridSub": `WhyHostForm-exportSectionGridSub-FS70i`,
	"exportText": `WhyHostForm-exportText-PohoY`,
	"exportLinkImg": `WhyHostForm-exportLinkImg-g1BJ9`,
	"vtrMiddle": `WhyHostForm-vtrMiddle-NQPe_`,
	"exportImg": `WhyHostForm-exportImg-ZxT4S`,
	"profileViewlabel": `WhyHostForm-profileViewlabel-YH36v`,
	"profileViewMainContent": `WhyHostForm-profileViewMainContent-Z2s1F`,
	"profileViewMain": `WhyHostForm-profileViewMain-JGccD`,
	"profileViewInner": `WhyHostForm-profileViewInner-NnSTa`,
	"profileImageSection": `WhyHostForm-profileImageSection-dOdwY`,
	"lastviewInner": `WhyHostForm-lastviewInner-OObuN`,
	"whyHostHoriLine": `WhyHostForm-whyHostHoriLine-DgyNz`,
	"tableGrid": `WhyHostForm-tableGrid-PSs0q`,
	"headingContent": `WhyHostForm-headingContent-JL04G`,
	"refundTextColor": `WhyHostForm-refundTextColor-YAI9s`,
	"dividerLine": `WhyHostForm-dividerLine-UGb8p`,
	"smallContent": `WhyHostForm-smallContent-ZaEJg`,
	"ChangeToUpperCase": `WhyHostForm-ChangeToUpperCase-Jpqbs`,
	"noBorder": `WhyHostForm-noBorder-hSwr1`,
	"siteAdminHeading": `WhyHostForm-siteAdminHeading-zabNO`,
	"siteAdminSubHeading": `WhyHostForm-siteAdminSubHeading-zP3E9`,
	"adminFormDivider": `WhyHostForm-adminFormDivider-NqP8a`,
	"errorMessage": `WhyHostForm-errorMessage-Y6b3I`,
	"labelText": `WhyHostForm-labelText-xSLGb`,
	"space1": `WhyHostForm-space1-sR4LQ`,
	"space2": `WhyHostForm-space2-xzAJW`,
	"space3": `WhyHostForm-space3-iaMq8`,
	"space4": `WhyHostForm-space4-cO_Cj`,
	"space5": `WhyHostForm-space5-DR0nz`,
	"space6": `WhyHostForm-space6-OCpKi`,
	"space7": `WhyHostForm-space7-h844H`,
	"spaceTop8": `WhyHostForm-spaceTop8-exqRy`,
	"spaceTop1": `WhyHostForm-spaceTop1-wrM4o`,
	"spaceTop2": `WhyHostForm-spaceTop2-UnHZ2`,
	"spaceTop3": `WhyHostForm-spaceTop3-IQAPt`,
	"spaceTop4": `WhyHostForm-spaceTop4-IbSSw`,
	"spaceTop5": `WhyHostForm-spaceTop5-RPUvF`,
	"spaceTop6": `WhyHostForm-spaceTop6-SKeYS`,
	"spaceTop7": `WhyHostForm-spaceTop7-NoZID`,
	"padding1": `WhyHostForm-padding1-CZFO8`,
	"padding2": `WhyHostForm-padding2-j4xJy`,
	"padding3": `WhyHostForm-padding3-M6eaT`,
	"padding4": `WhyHostForm-padding4-zKVMO`,
	"padding5": `WhyHostForm-padding5-IPf6l`,
	"padding6": `WhyHostForm-padding6-tl3xh`,
	"padding7": `WhyHostForm-padding7-OyCdl`,
	"paddingTop1": `WhyHostForm-paddingTop1-hfftI`,
	"paddingTop2": `WhyHostForm-paddingTop2-jy50P`,
	"paddingTop3": `WhyHostForm-paddingTop3-acB1e`,
	"paddingTop4": `WhyHostForm-paddingTop4-gHQiW`,
	"paddingTop5": `WhyHostForm-paddingTop5-UWp8A`,
	"paddingTop6": `WhyHostForm-paddingTop6-ancA_`,
	"paddingTop7": `WhyHostForm-paddingTop7-Rl2ZF`,
	"noPadding": `WhyHostForm-noPadding-dVw_l`,
	"textBold": `WhyHostForm-textBold-zQ3aE`,
	"textBolder": `WhyHostForm-textBolder-XpWvP`,
	"textNormal": `WhyHostForm-textNormal-htzyD`,
	"spaceBottom20": `WhyHostForm-spaceBottom20-acCQh`,
	"spaceBottom10": `WhyHostForm-spaceBottom10-wDFta`,
	"marginNone": `WhyHostForm-marginNone-JV1dw`,
	"spaceBottom15": `WhyHostForm-spaceBottom15-itRBu`,
	"marginTopNone": `WhyHostForm-marginTopNone-MQ305`,
	"spaceTop11": `WhyHostForm-spaceTop11-w6tda`,
	"spaceTop21": `WhyHostForm-spaceTop21-F_jr0`,
	"spaceTop20": `WhyHostForm-spaceTop20-VgSQ_`,
	"spaceTop10": `WhyHostForm-spaceTop10-sol1h`,
	"textDarkBlue": `WhyHostForm-textDarkBlue-sr85l`,
	"textLightBlue": `WhyHostForm-textLightBlue-MK289`,
	"textLightSandleGreen": `WhyHostForm-textLightSandleGreen-KaP9B`,
	"textLightBrown": `WhyHostForm-textLightBrown-B3ypj`,
	"textMediumMaroon": `WhyHostForm-textMediumMaroon-lcmOs`,
	"textBrown": `WhyHostForm-textBrown-KDmjw`,
	"textMaroon": `WhyHostForm-textMaroon-wP_25`,
	"textDarkBrown": `WhyHostForm-textDarkBrown-aJqYA`,
	"textMediumBrown": `WhyHostForm-textMediumBrown-ZnHIC`,
	"textSkyBlue": `WhyHostForm-textSkyBlue-_KE_d`,
	"textGray": `WhyHostForm-textGray-q96fV`,
	"sectionBorder": `WhyHostForm-sectionBorder-SdVGP`,
	"removeIcon": `WhyHostForm-removeIcon-wXEFX`,
	"whyFromGrid": `WhyHostForm-whyFromGrid-G8Bgg`
};
module.exports = ___CSS_LOADER_EXPORT___;
